import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { BaseBadge } from './BaseBadge';

type BetaBadgeProps = {
  className?: string;
};

export const BetaBadge: FC<BetaBadgeProps> = ({ className }) => {
  const { t } = useTranslation();

  return <BaseBadge className={twMerge('bg-yellow-200', className)}>{t('COMMON:beta')}</BaseBadge>;
};
